// front
export const FRONT_BUSINESS_URL = `${process.env.FRONT_HOST}/businesses/:id`;

// API
// V1
export const API_V1_BANKS = '/api/v1/banks';
export const API_V1_BANK_BRANCHES = '/api/v1/banks/:bankId/bank_branches';

// query parameter constants
export const LINE_WEB_VIEW_PARAMS = {
  openExternalBrowser: 1,
};
